import { useAuthorizedUser } from 'Services/User/useAuthorizedUser';
import { MARKETPLACE_AUDIO_POST } from 'Constants/articleTypes';

import type { ArticleTypeT } from 'Constants/articleTypes';

type ArgsT = {
  isProContent: boolean;
  isMpPaidSubscriber?: boolean;
  articleType?: ArticleTypeT;
};

export const useButtonLockStatus = ({
  isProContent,
  isMpPaidSubscriber,
  articleType,
}: ArgsT) => {
  const { isAnyProSubscriber, isProSubscriber } = useAuthorizedUser();
  const shouldLockMpPlay =
    articleType === MARKETPLACE_AUDIO_POST && !isMpPaidSubscriber;

  const isProLocked = isProContent && !isProSubscriber;
  const isLocked =
    articleType === MARKETPLACE_AUDIO_POST
      ? shouldLockMpPlay
      : !isAnyProSubscriber || isProLocked;

  return { isProLocked, isLocked };
};
